var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3336 1.31236C11.3336 0.944168 11.6321 0.645691 12.0003 0.645691H14.6669C15.0351 0.645691 15.3336 0.944168 15.3336 1.31236V13.3124C15.3336 13.6805 15.0351 13.979 14.6669 13.979H12.0003C11.6321 13.979 11.3336 13.6805 11.3336 13.3124V1.31236ZM12.6669 1.97902V12.6457H14.0003V1.97902H12.6669ZM6.00026 4.64569C6.00026 4.2775 6.29874 3.97902 6.66693 3.97902H9.3336C9.70179 3.97902 10.0003 4.2775 10.0003 4.64569V13.3124C10.0003 13.6805 9.70179 13.979 9.3336 13.979H6.66693C6.29874 13.979 6.00026 13.6805 6.00026 13.3124V4.64569ZM7.3336 5.31236V12.6457H8.66693V5.31236H7.3336ZM0.666931 7.97902C0.666931 7.61083 0.965408 7.31236 1.3336 7.31236H4.00026C4.36845 7.31236 4.66693 7.61083 4.66693 7.97902V13.3124C4.66693 13.6805 4.36845 13.979 4.00026 13.979H1.3336C0.965408 13.979 0.666931 13.6805 0.666931 13.3124V7.97902ZM2.00026 8.64569V12.6457H3.3336V8.64569H2.00026Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.5a5e13f7b4bbc19ed196f80e37fd5426.svg";
export { ForwardRef as ReactComponent };